var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layer-container"},[_c('layer-group',{attrs:{"id":"atlas","layers":_vm.atlasLayers}}),_c('layer-group',{attrs:{"id":"private","layers":_vm.simpleLayers}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }